export enum MESSAGE_FROM {
  MAIN = 'main',
  POPUP = 'popup',
}
